import {defaultIngredient} from "../../global/defaults";

interface IngredientModelProps {
    ingredient?: Ingredient,
    formData?: any
}

export class IngredientModel {
    public ingredient: Ingredient

    constructor({ingredient}: IngredientModelProps) {
        this.ingredient = defaultIngredient
        if (ingredient) {this.ingredient = ingredient; return}
    }

    public retrieveUnitString (unitVal?: Price | Mass) {
        if (unitVal) return unitVal.value + unitVal.unit
        return ""
    }

    public retrieveListData() {
        return [
            {
                label: "mass",
                unit: this.ingredient.mass.unit,
                value: this.ingredient.mass.value
            },
            {
                label: "price",
                unit: this.ingredient.price.unit,
                value: this.ingredient.price.value
            }
        ]
    }
}
